goog.provide('el8.appchart.providers.tooltips');

goog.require('el8.service.tooltip');


/**
 * Create and destroy the provider-icon tooltips
 * (e.g., in the provider list and profile details)
 */
el8.appchart.providers.tooltips = (function() {

    return {

        create: function(container) {
            el8.service.tooltip.create({
                anchor: $('.verified-icon', container),
                text: el8.template.appchart.providers.eConfirmedTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.emr-user-icon', container),
                text: el8.template.appchart.providers.emrUserTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.passport-user-icon', container),
                text: el8.template.appchart.providers.passportUserTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.main-providers-icon', container),
                text: el8.template.appchart.providers.mainProvidersTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.other-providers-icon', container),
                text: el8.template.appchart.providers.otherProvidersTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.care-team-providers-icon', container),
                text: el8.template.appchart.providers.careTeamProvidersTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.care-team-other-providers-icon', container),
                text: el8.template.appchart.providers.careTeamOtherProvidersTooltip()
            });
            // below are for the sharing icons
            el8.service.tooltip.create({
                anchor: $('.care-team-active-icon', container),
                text: el8.template.appchart.providers.careTeamActiveTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.care-team-active-not-sharing-icon', container),
                text: el8.template.appchart.providers.careTeamActiveNotSharingTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.care-team-inactive-and-sharing-icon', container),
                text: el8.template.appchart.providers.careTeamInactiveAndSharingTooltip()
            });
            el8.service.tooltip.create({
                anchor: $('.care-team-invite-outstanding-icon', container),
                text: el8.template.appchart.providers.careTeamInviteOutstandingTooltip()
            });
        },

        destroy: function(container) {
            el8.service.tooltip.destroy($('.verified-icon', container));
            el8.service.tooltip.destroy($('.emr-user-icon', container));
            el8.service.tooltip.destroy($('.passport-user-icon', container));
            el8.service.tooltip.destroy($('.main-providers-icon', container));
            el8.service.tooltip.destroy($('.other-providers-icon', container));
            el8.service.tooltip.destroy($('.care-team-active-icon', container));
            el8.service.tooltip.destroy($('.care-team-active-not-sharing-icon', container));
            el8.service.tooltip.destroy($('.care-team-inactive-icon', container));
            el8.service.tooltip.destroy($('.care-team-inactive-not-sharing-icon', container));
            el8.service.tooltip.destroy($('.care-team-invite-outstanding-icon', container));
        }

    };

})();